import {CompassIcon} from '@gaia/icons/controls';
import {ampli} from '@gaia/utils/gaia/trackAnalytics';
import SubscriptionTooltip from '@map/SubscriptionTooltip';
import type mapboxgl from 'mapbox-gl';
import {useCallback, useEffect, useState} from 'react';

export default function RotateControl({map}: {map: mapboxgl.Map | undefined}) {
    const [bearing, setBearing] = useState(0);

    const onRotate = useCallback(() => {
        if (!map) return;
        setBearing(Math.round(map.getBearing()));
    }, [map]);

    const center = useCallback(() => {
        if (!map) return;
        ampli.pressRotateControl({category: 'map2'});
        map.easeTo({bearing: 0});
    }, [map]);

    useEffect(() => {
        if (!map) return;
        map.on('rotate', onRotate);
        return () => {
            map.off('rotate', onRotate);
        };
    }, [map, onRotate]);

    return (
        <button
            style={{
                transform: `rotate(${-bearing}deg)`,
                background: 'none',
                border: 0,
                cursor: 'pointer',
                pointerEvents: 'auto',
                marginInline: -10,
                marginTop: 5,
                padding: 0,
            }}
            onClick={center}
        >
            <SubscriptionTooltip
                enterDelay={500}
                placement='right'
                title={
                    <>
                        <span style={{fontWeight: 'bold'}}>Adjust Bearing</span>
                        <br />
                        CTRL + Drag left/right
                    </>
                }
                subscription={undefined}
            >
                <CompassIcon style={{height: 50}} />
            </SubscriptionTooltip>
        </button>
    );
}
